(function () {
    // --- DOM Helfer ---

    /** Scroll-Lock für Body/HTML toggeln */
    const toggleScrollLock = (shouldLock) => {
        const action = shouldLock ? "add" : "remove";
        document.documentElement.classList[action]("aa-modal-open");
        document.body.classList[action]("aa-modal-open");
    };

    /** Öffnet das Modal */
    const openModal = (modal) => {
        modal.classList.add("aa-modal--open");
        modal.setAttribute("aria-hidden", "false");
        toggleScrollLock(true);
    };

    /** Schließt das Modal */
    const closeModal = (modal) => {
        modal.classList.remove("aa-modal--open");
        modal.setAttribute("aria-hidden", "true");
        toggleScrollLock(false);
    };

    /**
     * Sorgt dafür, dass das Modal im DOM existiert und gibt { modal, modalBody } zurück.
     */
    const ensureModal = () => {
        let modal = document.getElementById("aa-modal");
        let modalBody = document.getElementById("aa-modal-body");

        if (modal && modalBody) {
            return { modal, modalBody };
        }

        // --- Modal HTML Template ---
        const modalHTML = `
            <div id="aa-modal" class="aa-modal" aria-hidden="true">
                <div class="aa-modal__backdrop" data-aa-modal-close></div>
                <div class="aa-modal__dialog" role="dialog" aria-modal="true">
                    <div class="aa-modal__header">
                        <button class="aa-modal__close" type="button" aria-label="Schließen" data-aa-modal-close>×</button>
                    </div>
                    <div class="aa-modal__body" id="aa-modal-body"></div>
                </div>
            </div>
        `;


        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = modalHTML.trim(); // trim für Sicherheit
        modal = tempDiv.firstElementChild;    // << WICHTIG: firstElementChild
        document.body.appendChild(modal);

        modalBody = document.getElementById("aa-modal-body");

        // Klick-Handler für Schließen (Close-Button oder Backdrop)
        modal.addEventListener("click", (event) => {
            if (event.target.matches("[data-aa-modal-close]")) {
                closeModal(modal);
            }
        });

        // ESC schließt Modal
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && modal.classList.contains("aa-modal--open")) {
                closeModal(modal);
            }
        });

        return { modal, modalBody };
    };

    // --- Haupt-Click-Listener (Event Delegation) ---
    document.addEventListener("click", function (event) {
        // Nur linker Mausklick ohne Modifier (Strg, Cmd, Shift etc.)
        if (
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
        ) {
            return;
        }

        const link = event.target.closest("a[href]");
        if (!link) return;

        // URL parsen
        let url;
        try {
            url = new URL(link.href, window.location.origin);
        } catch (e) {
            return; // ungültige URL, nichts tun
        }

        const modalParam = (url.searchParams.get("modal") || "").toLowerCase();
        if (modalParam !== "true" && modalParam !== "1") {
            return; // kein Modal-Link
        }

        event.preventDefault(); // Navigation verhindern

        const modalParts = ensureModal();
        if (!modalParts) return;

        const { modal, modalBody } = modalParts;

        // ?modal-Parameter entfernen, damit die geladene Seite „normal“ ist
        url.searchParams.delete("modal");

        // Modal öffnen & Ladezustand anzeigen
        openModal(modal);
        modalBody.innerHTML =
            '<div style="text-align: center; padding: 50px;">Lade Inhalt...</div>';

        // Inhalt per fetch holen
        fetch(url.toString())
            .then((response) => {
                if (!response.ok) throw new Error(`HTTP-Fehler: ${response.status}`);
                return response.text();
            })
            .then((html) => {
                const doc = new DOMParser().parseFromString(html, "text/html");

                // Relevanten Inhalt suchen
                let pageContent =
                    doc.querySelector("#PageContainer") || // 1. Shopify-Standard
                    doc.querySelector("main") ||           // 2. <main>
                    doc.body;                              // 3. Fallback: alles

                if (!pageContent) {
                    modalBody.innerHTML =
                        "<p style='padding: 20px;'>Inhalt nicht gefunden.</p>";
                    return;
                }

                // Optional: Seitentitel im Modal ausblenden
                const pageTitle = pageContent.querySelector(".page-title, h1:first-child");
                if (pageTitle) {
                    pageTitle.style.display = "none";
                }

                modalBody.innerHTML = pageContent.innerHTML;
            })
            .catch((error) => {
                console.error("aa-modal: Fehler beim Laden der Seite:", error);
                modalBody.innerHTML = `<p style='padding: 20px;'>Es gab einen Fehler beim Laden der Seite: ${error.message}</p>`;
            });
    });
})();
